
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabandbusserviceinhinjewadi() {



    const cardData =
    {
        keyword: 'Corporate Cab and Bus Services in Hinjewadi',
        heading: 'etravo :  Corporate Cab and Bus Services in Hinjewadi',
        headingDescription: 'eTravo offers specialized Corporate Cab and Bus Services in Hinjewadi, Pune’s leading IT and business district. Serving major tech parks and corporate campuses, we provide executive cab services for business meetings, airport transfers, and VIP movements, along with large-capacity buses for employee transportation. Our fleet is equipped with modern amenities, professional chauffeurs, and GPS-enabled tracking to ensure punctuality, safety, and comfort. Choose eTravo in Hinjewadi for dependable and scalable corporate mobility solutions that keep your business running smoothly.',

        top: 'Top Places to Visit in Hinjewadi with etravo',
  "topPlaces": [
    {
      "title": "Butterfly Trampoline Park",
      "description": "An energetic indoor amusement center featuring expansive trampoline zones, a dedicated kids' area, and facilities for hosting birthday parties and group events. It's a fun destination for families and fitness enthusiasts alike."
    },
    {
      "title": "SPOT18 Mall",
      "description": "A modern shopping and entertainment complex offering a variety of retail outlets, diverse dining options, a cinema, and a gaming zone, making it a popular hangout spot for locals and visitors."
    },
    {
      "title": "Cinépolis – WestEnd Mall",
      "description": "A premium multiplex cinema located in WestEnd Mall, providing a top-notch movie-watching experience with advanced sound and visual systems, along with comfortable seating arrangements."
    },
    {
      "title": "E-Square Carnival Xion",
      "description": "A contemporary multiplex cinema offering the latest movie screenings, complemented by a food court and gaming arcade, catering to entertainment needs of all age groups."
    },
    {
      "title": "Sentosa Resorts and Water Park",
      "description": "A family-friendly resort featuring a water park with various slides and pools, along with comfortable accommodations and dining options, ideal for weekend getaways and day trips."
    },
    {
      "title": "Kasarsai Dam",
      "description": "A serene spot located near Hinjewadi, perfect for picnics and nature walks. The dam offers picturesque views, especially during sunrise and sunset, attracting photography enthusiasts."
    },
    {
      "title": "Marunji Hills",
      "description": "A hidden gem for trekking enthusiasts, offering lush green trails and panoramic views of the surrounding landscape. It's a peaceful retreat for nature lovers seeking solitude."
    },
    {
      "title": "Shree Shiv Chhatrapati Sports Complex",
      "description": "A well-equipped sports facility hosting various national and international sporting events. The complex includes stadiums for athletics, swimming, and indoor games, promoting sports and fitness in the region."
    },
    {
      "title": "Shri Prati Shirdi Sai Baba Temple",
      "description": "A spiritual destination replicating the famous Shirdi Sai Baba Temple, attracting devotees seeking peace and blessings. The temple's architecture and serene ambiance offer a tranquil experience."
    },
    {
      "title": "Rajiv Gandhi Infotech Park",
      "description": "A prominent IT hub housing numerous multinational companies and tech parks. While primarily a business district, its modern infrastructure and surroundings reflect the rapid development of Hinjewadi."
    }
  ],
     "services": [
    {
      "name": "Hinjewadi IT Park Corporate Transport",
      "description": "eTravo offers specialized corporate transport solutions for companies located in Hinjewadi IT Park, one of Pune’s busiest tech hubs. We understand the dynamic scheduling needs of IT employees and provide reliable, tech-enabled transport that includes GPS tracking, shift-based planning, and dedicated customer support. Our services are perfect for startups, MNCs, and BPOs looking for efficient, scalable, and safe daily transportation."
    },
    {
      "name": "Cab & Bus Hire for Tech Companies in Hinjewadi",
      "description": "Designed specifically for the IT sector, eTravo’s cab and bus hire services in Hinjewadi offer tailored solutions for tech companies. From daily staff movement to executive visits and client pickups, we provide clean, AC cabs and buses with professional drivers. Choose from flexible rental plans—hourly, daily, or monthly—backed by responsive service and real-time coordination."
    },
    {
      "name": "Employee Shuttle Services Hinjewadi",
      "description": "Our employee shuttle services in Hinjewadi help reduce commuting stress while improving employee retention and punctuality. eTravo creates optimized shuttle routes that cater to major residential clusters around Pune. Vehicles are equipped with air-conditioning, live tracking, and emergency support, ensuring safe and timely travel for your IT and support staff across all shifts."
    },
    {
      "name": "Daily Office Commute Bus Rentals Hinjewadi",
      "description": "eTravo provides dependable daily bus rentals for office commutes in Hinjewadi. We cater to single or multiple shifts with our fleet of AC minibuses and full-sized coaches. Designed for comfort and consistency, our services include route mapping, vehicle rotation, and backup support to ensure uninterrupted transportation for your entire team—even during peak traffic hours."
    },
    {
      "name": "AC Buses and Cabs for Corporate Offices in Hinjewadi",
      "description": "Ensure your team travels in comfort with eTravo’s AC buses and cabs, ideal for Hinjewadi-based corporate offices. Whether for executive meetings, team events, or daily commuting, our vehicles are well-maintained, sanitized, and driven by trained chauffeurs. Our fleet includes everything from hatchbacks to luxury coaches, all bookable through a seamless digital interface or dedicated support desk."
    },
    {
      "name": "Cost-Effective Staff Transport in Hinjewadi",
      "description": "eTravo offers affordable staff transport services in Hinjewadi without compromising on safety or service quality. Ideal for growing tech firms and startups, mobility and route-pooling options help reduce costs while maintaining timely and reliable employee transportation. Benefit from structured billing, flexible contracts, and scalable operations that adapt as your business grows."
    },
    {
      "name": "Corporate Shuttle for Tech Parks in Hinjewadi",
      "description": "Our corporate shuttle services for Hinjewadi tech parks offer dependable connectivity between business campuses and residential areas across Pune. Whether you're operating across Phase 1, 2, or 3, eTravo ensures your workforce travels smoothly with fixed-route or flexible shuttle plans. With a modern fleet and real-time service visibility, we guarantee timely operations across all major IT campuses."
    }
  ],
  "tableData": [
    ["Hinjewadi IT Park Corporate Transport", "Cab & Bus Hire for Tech Companies in Hinjewadi"],
    ["Employee Shuttle Services Hinjewadi", "Daily Office Commute Bus Rentals Hinjewadi"],
    ["AC Buses and Cabs for Corporate Offices in Hinjewadi", "Cost-Effective Staff Transport in Hinjewadi"],
    ["Corporate Shuttle for Tech Parks in Hinjewadi", ""]
  ],






"whychoose": [
    {
        "WhyChooseheading": "Reliable and On-Time Transport in Hinjewadi IT Hub",
        "WhyChoosedescription": "Hinjewadi is Pune’s leading IT and business zone, where punctuality and efficiency are critical. eTravo ensures dependable corporate cab and bus services to support tech parks, BPOs, startups, and MNCs in Hinjewadi. We offer precise timing, real-time tracking, and seamless coordination to keep your workforce moving without delays."
    },
    {
        "WhyChooseheading": "Fleet Designed for Corporate Comfort and Scale",
        "WhyChoosedescription": "Our extensive fleet includes everything from air-conditioned sedans for executives to large-capacity buses for employee shuttle services. Each vehicle is well-maintained and equipped with cushioned seating, ample legroom, luggage space, and onboard safety features—ideal for daily office commutes or special corporate events."
    },
    {
        "WhyChooseheading": "Expert Drivers Familiar with Hinjewadi's Traffic Flow",
        "WhyChoosedescription": "Our professional drivers are well-versed in Hinjewadi’s traffic dynamics and shift timings. Whether it's navigating the Phase 1, 2, or 3 IT clusters or optimizing pickup routes during rush hours, our drivers ensure your staff experiences smooth, stress-free, and timely commutes every day."
    },
    {
        "WhyChooseheading": "Transparent Pricing and Scalable Billing Options",
        "WhyChoosedescription": "With eTravo, corporate clients in Hinjewadi benefit from clear, upfront pricing and flexible billing models. Whether it’s fixed monthly packages, shift-based rates, or on-demand services, we tailor our pricing to match your transport budget with no hidden costs or last-minute surprises."
    },
    {
        "WhyChooseheading": "Safety-First Corporate Travel Approach",
        "WhyChoosedescription": "Safety is non-negotiable. Our vehicles are fitted with GPS tracking, CCTV (on request), emergency kits, seat belts, and fire extinguishers. Regular sanitation and maintenance ensure a secure and hygienic environment—making eTravo the preferred choice for companies prioritizing employee well-being."
    },
    {
        "WhyChooseheading": "Round-the-Clock Transport Support for All Shifts",
        "WhyChoosedescription": "Given Hinjewadi’s 24/7 operations across IT and BPO sectors, eTravo offers full-time support with transport solutions for early morning, late-night, and rotating shifts. Our backend coordination team is available at all hours to handle changes, updates, or emergencies in real-time."
    },
    {
        "WhyChooseheading": "Smart Booking and Real-Time Ride Management",
        "WhyChoosedescription": "Our digital platform lets HR and admin teams easily manage employee transport in Hinjewadi. Book and modify rides, view vehicle locations, get driver details, and receive alerts—all through a single dashboard. We simplify transport operations so your team can focus on productivity."
    },
    {
        "WhyChooseheading": "Custom Corporate Transport Plans for Every Business Size",
        "WhyChoosedescription": "Whether you're a startup with 10 employees or a global enterprise with 1,000+, eTravo builds transport plans that scale with you. From point-to-point office pickups to outstation meetings and event logistics, we craft personalized solutions tailored to your company’s unique needs in Hinjewadi."
    }
]


























    }


  // Corporate Cab and Bus Services in Hinjewadi – eTravo

const faqData = [
    [
        {
            question: 'What types of corporate transport services does eTravo offer in Hinjewadi?',
            answer: 'eTravo provides comprehensive corporate cab and bus services in Hinjewadi, including daily employee transport, executive travel, shuttle services, and transport for IT parks and SEZs.',
        },
        {
            question: 'Can eTravo support IT companies and BPOs with large-scale employee transportation?',
            answer: 'Yes, eTravo specializes in large-scale employee commute solutions with shift-based scheduling, fleet optimization, and end-to-end route planning tailored for IT and BPO hubs in Hinjewadi.',
        },
        {
            question: 'What types of vehicles are offered for corporate clients in Hinjewadi?',
            answer: 'Our fleet includes sedans, hatchbacks, SUVs, tempo travellers, and AC buses ranging from 13 to 50 seats — all equipped to handle daily operations with comfort and safety.',
        },
        {
            question: 'Are GPS tracking and safety systems included in eTravo’s transport solutions?',
            answer: 'Absolutely. All vehicles are GPS-enabled, and clients get access to real-time tracking, automated attendance logs, driver verification, and safety compliance reporting.',
        },
        {
            question: 'Can eTravo manage one-time or event-based transport needs in Hinjewadi?',
            answer: 'Yes, we provide flexible transport options for corporate events, townhalls, audits, client visits, and outstation business trips — with full support and professional coordination.',
        },
        {
            question: 'Is there a dedicated account manager for corporate clients in Hinjewadi?',
            answer: 'Yes, each corporate account is assigned a dedicated relationship manager to handle operations, queries, reporting, and performance tracking seamlessly.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Pravin Deshpande',
        designation: 'Facility Manager, CodeVista Technologies',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has been instrumental in managing our employee transport at Hinjewadi Phase 2. Their service is on time, the vehicles are clean, and support is quick and efficient.”',
    },
    {
        name: 'Ms. Priya Kulkarni',
        designation: 'HR Executive, LogiTech Systems Pvt. Ltd.',
        rating: [1, 1, 1, 1, 1],
        text: '“We’ve been using eTravo’s corporate transport service in Hinjewadi for over 18 months. The experience has been smooth, reliable, and scalable for our growing teams.”',
    },
];


















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab and Bus Services in Hinjewadi",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-bus-service-hinjewadi.jpg",
  "description": "Reliable corporate cab and bus services in Hinjewadi IT Park by eTravo. Perfect for tech companies, employee shuttle services, and daily office commutes with cost-effective AC vehicles and professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3350"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2399",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-and-bus-services-in-hinjewadi"
  }
};





    return (
        <div>

<Helmet>
  <title>Corporate Cab and Bus Services in Hinjewadi | IT Park Shuttle & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus services in Hinjewadi IT Park with eTravo for tech companies, employee shuttle, and daily office commute. Affordable, reliable, and AC vehicles available." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/12.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabandbusserviceinhinjewadi;